<script lang='ts'>
    import { Icon, Input, InputGroup, Popover } from "sveltestrap"
    import type { Contain } from "../Model/Contain"
    import type { Param } from "../Model/Param"
    import { containsService, paramsService } from "../services"
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    let contains: Contain[];
    let containsShow: Contain[] = [];
    let params: Param[];

    export let searchFilterComponent = {
        register : null,
        selectRegister : null,
        selectType : null,
        date : null
    };

    export let type: string;

    let inputRegister = null;
    let selectRegister = null;
    let selectDate = null;
    let selectType = null;
    let startDate = null;
    let endDate = null;
    
    let date = new Date();

    function load(searchFilter) {
        dispatch('load', searchFilter);
    }

    $: loadInputDate();
    $: loadConstains();

    async function loadConstains() {

        params = await paramsService.findByType('modules');
        contains = await containsService.find();

        const paramSelect = params.find(p => p.name == 'Registro General de Entrada y Salida');

        if (!paramSelect) {
        return;
        }

        for (const contain of contains) {
        if (contain.moduleId == paramSelect.id) {
            containsShow.push(contain)
        }
        }

        containsShow.sort((a, b) => {
        return a.name < b.name ? -1 : 1;
        });

        containsShow = containsShow;
    }

    function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];
        loadData(selectedDates,'date');
    }

    function loadData(data, type) {
        if (type == 'register') {
            searchFilterComponent.register = data;
        } else if (type == 'selectRegister') {
            if(data == null) {
                searchFilterComponent.selectRegister = 'both';
                inputRegister = null;
                searchFilterComponent.register = null;
            } else {
                searchFilterComponent.selectRegister = data;
            }
        } else if (type == 'selectType') {
            searchFilterComponent.selectType = data;
        }else {
            if (selectDate == null) {
                searchFilterComponent.selectRegister = 'both';
                searchFilterComponent.date = data;
            } else{
                searchFilterComponent.date = data;
            }
            
        }
        load(JSON.stringify(searchFilterComponent));
    }

    function replaceDate() {
        if (type == 'entrada') {
            let popover = document.getElementById('popover');
            popover.hidden = true;
        } else {
            let popover = document.getElementById('popoverCitation');
            popover.hidden = true;
        }
        
        let selectedDates = [startDate, endDate];
        loadData(selectedDates,'date');
    }

    function clearFilter() {
        searchFilterComponent = {
            register : null,
            selectRegister : null,
            selectType : null,
            date : null
        };
        inputRegister = null;
        selectType = null;
        loadInputDate();
    }
</script>

<div class="container mt-3">
  <div class="row">
      <div class="col-3 col-sm-3 mb-3">
          <!-- Select para tipo de registro a filtrar -->
          <select bind:value={selectRegister} on:change={() => loadData(selectRegister,'selectRegister')} class='form-select'>
              <option value={null} selected>Seleccionar registro</option>
              <option value='both'>Ambos</option>
              <option value='registerIn'>Entrada</option>
              <option value='registerOut'>Salida</option>
          </select>
      </div>
      <!-- Input para colocar el número del registro -->
      <div class="col-3 col-sm-3 mb-3">
          <form on:submit|preventDefault={() => loadData(inputRegister,'register')}>
              <InputGroup>
                  <Input placeholder="Encuentra un registro" bind:value={inputRegister} />
                  <button type="submit" class="btn btn-primary"><Icon name="search" /></button>
              </InputGroup>
          </form>
      </div>
      <!-- Select para el tipo -->
      <div class="col-3 col-sm-3 mb-3">
          <select bind:value={selectType} on:change={() => loadData(selectType, 'selectType')} class='form-select'>
              <option selected value={null}>Seleccionar tipo</option>
              {#each containsShow as contain}
                  <option value={contain.id}>{contain.name}</option>
              {/each}
          </select>
      </div>
      <!-- Input para espcificar el rango de fechas para filtrar -->
      <div class="col-3 col-sm-3 mb-3 d-flex">
          
          {#if type == 'entrada'}
            <button class='btn border border-dark' id='pop'>
                {startDate} - {endDate}
            </button>
            <Popover placement="bottom" target="pop" id='popover'>
                <div id='startDate'>
                    <p>Desde:</p>
                    <Input
                        type='date'
                        bind:value={startDate}
                    />
                </div>
                <div id='endDate'>
                    <p>Hasta</p>
                    <Input
                        type='date'
                        bind:value={endDate}
                    />
                </div>
                <button class='btn btn-primary mt-3' on:click={replaceDate}>Buscar</button>
            </Popover>
          {:else}
            <button class='btn border border-dark' id='popCitation'>
                {startDate} - {endDate}
            </button>
            <Popover placement="bottom" target="popCitation" id='popoverCitation'>
                <div id='startDate'>
                    <p>Desde:</p>
                    <Input
                        type='date'
                        bind:value={startDate}
                    />
                </div>
                <div id='endDate'>
                    <p>Hasta</p>
                    <Input
                        type='date'
                        bind:value={endDate}
                    />
                </div>
                <button class='btn btn-primary mt-3' on:click={replaceDate}>Buscar</button>
            </Popover>
        {/if}

          <button class='btn btn-primary ms-1' on:click={clearFilter}><Icon name='eraser' /></button>
      </div>
  </div>
</div>
